import graphqlClient from "@/GQLClient";
import {
  GetPictogramsDocument,
  SavePictogramDocument,
  type PictogramInput,
} from "@/graphql/generated-types";
import SentryGraphQLError from "@/helpers/exceptions/SentryGraphQLError";

const getAll = async () => {
  const response = await graphqlClient.query({
    query: GetPictogramsDocument,
    fetchPolicy: "no-cache",
    errorPolicy: "all",
  });

  if (response.data.pictograms) {
    return response.data.pictograms;
  }

  throw new SentryGraphQLError(`api.pictograms.getAll`, response);
};

const save = async (pictogram: PictogramInput) => {
  const response = await graphqlClient.query({
    query: SavePictogramDocument,
    variables: {
      pictogram,
    },
    fetchPolicy: "no-cache",
    errorPolicy: "all",
  });

  if (response.data.resource?.savePictogram?.success) {
    return response.data.resource.savePictogram;
  }

  throw new SentryGraphQLError(`api.pictograms.save`, response);
};

export default {
  getAll,
  save,
};
